import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Services from "@/components/Services";
import FordHighlight from "@/components/FordHighlight";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import Reviews from "@/components/Reviews";
import BookingForm from "@/components/BookingForm";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import useDocumentMeta from "@/hooks/useDocumentMeta";

export default function Home() {
  const location = useLocation();

  useDocumentMeta({
    title:
      "Autó-Szerelem | Séra Autószervíz Debrecen — BMW & Q-Service",
    description:
      "Profi autószerviz Debrecenben. Klímatöltés, MotulEVO automataváltó-olajcsere, gumiszerelés, centrírozás, fékjavítás, futómű és teljes körű Q-Service javítás. BMW szakszerviz külön részleggel. Időpontfoglalás online.",
    path: "/",
  });

  // Scroll to hash on load (e.g. /#foglalas from another page)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <FordHighlight />
        <Gallery />
        <About />
        <Reviews />
        <BookingForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
